import React from "react";
import draftToHtml from "draftjs-to-html";
import { useMicroContent } from "./hooks/useMicroContent";
import styled from "styled-components";

const MicroContent = ({
    defaultContent,
    defaultTitleText,
    microContent = {},
    ...props
}) => {
    const { content, title, isEditMode, getEntityMarkup } = useMicroContent({
        defaultContent,
        defaultTitleText,
        microContent,
    });

    if (!content && !isEditMode) {
        // Return null if no content is provided
        return null;
    }
    return (
        <div {...props}>
            {title && (
                <h2
                    className="border-bottom mb-2 h4"
                    style={{ borderColor: "var(--bs-gray-200)" }}
                >
                    {title}
                </h2>
            )}
            <McWrapper>
                <div
                    dangerouslySetInnerHTML={{
                        __html:
                            typeof content === "object"
                                ? draftToHtml(
                                      content,
                                      undefined,
                                      false,
                                      getEntityMarkup
                                  )
                                : content,
                    }}
                />
            </McWrapper>
        </div>
    );
};

const McWrapper = styled.div`
    img {
        max-width: 100%;
    }
`;

export default MicroContent;
